import { Loader2, Play, Square } from "lucide-preact";
import { SelectedMark } from "./SettingsCard";

export type NarratorOptionButtonProps = {
  flag: string;
  title: string;
  isSelected: boolean;
  isPlaying: boolean;
  isLoading: boolean;
  onClick: () => void;
  onPlaySample: () => void;
};

const SAMPLE_ICON = "text-gray-600 dark:text-gray-400";

const SampleIcon = ({ isPlaying, isLoading }: { isPlaying: boolean; isLoading: boolean }) => {
  if (isLoading) {
    return <Loader2 size={16} class={`${SAMPLE_ICON} animate-spin`} />;
  }
  return isPlaying ? <Square size={16} class={SAMPLE_ICON} fill="currentColor" /> : <Play size={16} class={SAMPLE_ICON} />;
};

export const NarratorOptionButton = ({ flag, title, isSelected, isPlaying, isLoading, onClick, onPlaySample }: NarratorOptionButtonProps) => (
  <div
    onClick={onClick}
    class={`w-full flex items-center justify-between p-4 rounded-lg border-2 transition-all cursor-pointer hover:border-gray-300 dark:hover:border-gray-600 ${
      isSelected ? "border-blue-500 bg-blue-50 dark:bg-blue-900/20" : "border-gray-200 dark:border-gray-700"
    }`}
  >
    <div class="flex items-center space-x-3">
      <button
        type="button"
        onClick={(event) => {
          event.stopPropagation();
          onPlaySample();
        }}
        class="p-2 rounded-full hover:bg-gray-200 dark:hover:bg-gray-700 transition-colors flex-shrink-0 cursor-pointer"
        aria-label={isPlaying ? "Stop sample" : "Play sample"}
      >
        <SampleIcon isPlaying={isPlaying} isLoading={isLoading} />
      </button>
      <span class="text-2xl">{flag}</span>
      <div class="font-medium text-gray-900 dark:text-white">{title}</div>
    </div>
    {isSelected && <SelectedMark />}
  </div>
);
